import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
} from "@vue/composition-api";
import router from "@/router";

export default function useBannerInfo() {
  const modeEditor = ref(true)
  const stepActive = ref(0);
  const bannerId = ref(0)

  const scrollToTop = () => {
    const rootEle = document.documentElement
    rootEle.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const checkFormCreateOrEdit = () => {
    const bannerIdParams = router.currentRoute.params.bannerId || router.currentRoute.query.bannerId
    if(bannerIdParams) {
      modeEditor.value = false
      bannerId.value = parseInt(bannerIdParams)
    }
  }
  
  const onGetBannerId = id => {
    bannerId.value = id
  }

  const onNextStep = () => {
    stepActive.value = stepActive.value++;
  };

  const onPreviousStep = () => {
    stepActive.value = stepActive.value--;
  };

  onBeforeMount(() => {
    if (localStorage.getItem('activeTab') !== null) {
      stepActive.value = parseInt(localStorage.getItem('activeTab'))
    } else {
      localStorage.setItem('activeTab', stepActive.value)
    }
  })

  watch(
    stepActive,
    () => {
      localStorage.setItem('activeTab', stepActive.value)
    },
    { deep: true },
  )

  onBeforeMount(()=> {
    checkFormCreateOrEdit()
  })

  return {
    stepActive,
    modeEditor,
    onNextStep,
    onPreviousStep,
    scrollToTop,
    onGetBannerId,
    bannerId
  };
}
